<template>
  <div>
    <div
      style="background-color: white; padding: 9px 20px; text-align: justify"
    >
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Perturb-Seq">
          <span style="font-size: 20px; font-weight: bolder"
            >PerturbDB have categorized 66 Perturb-Seq datasets in a table.
            Users can obtain comprehensive data information in PerturbDB from
            this page.</span
          >
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Dataset1.png"
            />
          </div>
          <span style="font-size: 20px; font-weight: bolder"
            >By clicking the first column, users can enter the page for the
            specific dataset. For example, let's click "SC00001". Here's what
            you will find :</span
          >
          <div style="margin-left: 15px; font-size: 18px">
            1. Information of the published articles related to the SC00001
            dataset.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Datasets2.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            2. A bar chart showing the perturbation efficiency of the top 50
            genes in the SC00001 dataset.
            <!-- The table beneath the graph offers details on
        the count of perturbed cells and the perturbation rate for each gene.
        Clicking on the first column will navigate to the detailed information
        page following gene perturbation. ; -->
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Dataset2.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            3. The table on the right offers details on the count of perturbed
            cells and the perturbation rate for each gene. Clicking on the first
            column will navigate to the detailed information page following gene
            perturbation.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Dataset3.png"
            />
          </div>
          <!-- 新增的常规umap降维分析聚类 -->
          <div style="margin-left: 15px; font-size: 18px">
            4. PerturbDB have applied the shared nearest neighbor (SNN)
            clustering method to Perturb-Seq datasets and have displayed the
            clustering results via UMAP on the detailed information page.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1DatasetUMAP.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            5. The similarity of cell population after perturbations is
            represented through a table and a network diagram.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Dataset4.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            6. Next, PerturbDB displays the identified Perturbation clusters in
            this dataset. Clicking on the first column will redirect to the
            detailed information page for this perturbation cluster. If no
            perturbation cluster was identified in the dataset, this module will
            not present.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Dataset5.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            7. Furthermore, this page includes a query table containing
            significantly differentially expressed genes from whole DEGs of the
            dataset. By inputting a gene of interest, users can find putative
            regulatory factors for significant changes in the gene of interest.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Dataset6.png"
            /></div
        ></a-tab-pane>
        <a-tab-pane key="2" tab="Bulk perturbation RNA-Seq">
          <span style="font-size: 20px; font-weight: bolder"
            >PerturbDB have compiled a collection of 2,999 bulk perturbation
            RNA-Seq datasets as a supplement. Below is a detailed list of the
            dataset and an entry for data analysis results.</span
          >
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Bulk1.png"
            />
          </div>
          <span style="font-size: 20px; font-weight: bolder"
            >For example, let's search and click "BK01606". Here's what you will
            find.</span
          >
          <div style="margin-left: 15px; font-size: 18px">
            1. Information of the perturbed gene.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Bulk2.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            2. Interactive volcano plot and table of differentially expressed
            genes. PerturbDB offers convenient querying and downloading
            capabilities.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Bulk3.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            3. PerturbDB performed gene set enrichment analysis of differential
            expressed genes, switch the tabs could preview the enrichment
            results of Hallmark ;
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Bulk4.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            4. "Cancer Associations" module contains the aberrant expression
            patterns of perturbated genes in pan-cancer and their correlation
            with patients' prognosis survival ;
          </div>

          <div style="text-align: center">
            <a-tabs>
              <!-- <a-tab-pane
                    key="1"
                    tab="PART I : Differential Expression Analysis"
                  >
                    <img
                      width="60%"
                      height="100%"
                      src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Gene5_boxplot.png"
                    />
                  </a-tab-pane> -->
              <a-tab-pane
                key="1"
                tab="PART I : Gene Expression Profile across All Cancers"
              >
                <img
                  width="60%"
                  height="100%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Bulk5.png"
                />
              </a-tab-pane>
              <a-tab-pane key="2" tab="PART II : Survival Plots">
                <img
                  width="60%"
                  height="100%"
                  src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1Bulk6.png"
                />
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="Perturbation scATAC-Seq">
          <span style="font-size: 20px; font-weight: bolder"
            >PerturbDB have compiled a collection of 6 perturbation single-cell
            ATAC-seq (scATAC-seq) datasets as a supplement. Below is a detailed
            list of the dataset and an entry for data analysis results.</span
          >
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1scATAC1.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            1. Information of the dataset.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1scATAC2.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            2. Percentages in perturbation cell.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1scATAC3.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            3. PerturbDB have applied the shared nearest neighbor (SNN)
            clustering method to perturbation scATAC-Seq datasets and have
            displayed the clustering results via UMAP on the detailed
            information page.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1scATAC4.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            4. Differential significance analysis of gene activity scores
            following gene perturbation was conducted using FindMarkers function
            by Seurat.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1scATAC5.png"
            />
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
